import "core-js/modules/es.array.concat.js";
import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 业态列表 #10024 */
export function getBusFormat() {
  return request("".concat(BASE_URL) + "/erp/customer/busFormatList", METHOD.GET);
}

/* 保存 审核通过 审核拒绝（#10025） */
export function changApprovalResult(data) {
  return request("".concat(BASE_URL) + "/customer/changApprovalResult", METHOD.PUT, data);
}

/* 修改账号状态（#10027） */
export function changeStatus(data) {
  return request("".concat(BASE_URL) + "/customer/changeStatus", METHOD.PUT, data);
}

/* 修改账号 #10026 */
export function changAccount(data) {
  return request("".concat(BASE_URL) + "/customer/changAccount", METHOD.PUT, data);
}

/* 删除得意先 #10028 */
export function deleteErpcustomerByid(id) {
  return request("".concat(BASE_URL) + "/erp/customer/" + id, METHOD.DELETE);
}
/* 导入得意先（#10029） */
export function exportErp(data) {
  return request("".concat(BASE_URL) + "/erp/customer/export", METHOD.POST, data);
}

/* 可见性配置保存得意先接口（#10036） */
export function saveErp(data) {
  return request("".concat(BASE_URL) + "/yy/product/view", METHOD.PUT, data);
}

/* 得意先列表接口（#10031） */
export function getErpList(data) {
  return request("".concat(BASE_URL) + "/erp/customer/list", METHOD.POST, data);
}

/* 担当者列表（#10032） */
export function getSellerList(data) {
  return request("".concat(BASE_URL) + "/erp/customer/sellerList", METHOD.GET, data);
}

/* 根据得意先code 获取得意先信息（#10033） */
export function getCustomerDetail(data) {
  return request("".concat(BASE_URL) + "/erp/customer/detail", METHOD.GET, data);
}

/* 获取客户地址数据列表（#80） */
export function getAddressList(data) {
  return request("".concat(BASE_URL) + "/customer/address/list", METHOD.GET, data);
}

/* 获取账号/得意先详情（#10034） */
export function getCustomerDetailedByid(data) {
  return request("".concat(BASE_URL) + "/erp/customer/detailById", METHOD.GET, data);
}

/* 请求先列表（#10050） */
export function getPayersList(data) {
  return request("".concat(BASE_URL) + "/erp/customer/payers", METHOD.GET, data);
}

/* 都道府县下拉列表 #220） */
export function getOnlyIdAndNameList() {
  return request("".concat(BASE_URL) + "/deliveryArea/OnlyDetailIdAndName/list", METHOD.GET);
}

// 获取咨询列表内容
export function getContactusList(page, size) {
  return request("".concat(BASE_URL) + "/erp/customer/contactUsList?page=".concat(page, "&size=").concat(size), METHOD.GET);
}

// 获取得意先商品列表内容
export function getErpgoodsList(data) {
  return request("".concat(BASE_URL) + "/customer/product/list", METHOD.GET, data);
}
export default {
  getBusFormat: getBusFormat,
  changApprovalResult: changApprovalResult,
  changeStatus: changeStatus,
  saveErp: saveErp,
  changAccount: changAccount,
  deleteErpcustomerByid: deleteErpcustomerByid,
  exportErp: exportErp,
  getErpList: getErpList,
  getSellerList: getSellerList,
  getCustomerDetail: getCustomerDetail,
  getAddressList: getAddressList,
  getCustomerDetailedByid: getCustomerDetailedByid,
  getPayersList: getPayersList,
  getOnlyIdAndNameList: getOnlyIdAndNameList,
  getContactusList: getContactusList,
  getErpgoodsList: getErpgoodsList
};